import React from 'react';
import PropTypes from 'prop-types';
import './Footer.css';

const Footer = ({ email, phone }) => {
  return (
    <footer className="footer">
      <div className="footer-content">
        <div className="footer-section">
          <h3>York Travelers</h3>
          <p>Exploring the world together</p>
        </div>
        <div className="footer-section">
          <h3>Contact</h3>
          <p>Email: {email}</p>
          <p>Phone: {phone}</p>
        </div>
      </div>
      <div className="footer-bottom">
        <p>&copy; {new Date().getFullYear()} York Travelers. All rights reserved.</p>
      </div>
    </footer>
  );
};

Footer.propTypes = {
  email: PropTypes.string.isRequired,
  phone: PropTypes.string.isRequired,
};

Footer.defaultProps = {
  email: process.env.REACT_APP_CONTACT_EMAIL || 'bob.reed1@comcast.net',
  phone: process.env.REACT_APP_CONTACT_PHONE || '(717) 505-8513',
};

export default Footer; 